import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import MetaTags from "./index";
import { jsx as _jsx } from "react/jsx-runtime";
const tags = {
  vod: {
    title: "お知らせ | SPOOX(スプークス)",
    keywords: "SPOOX,スプークス,動画配信,見放題,レンタル,お知らせ",
    description: "SPOOX(スプークス)からのお知らせ一覧。SPOOX(スプークス)では、スポーツや映画やアニメなど、様々な動画を配信中です。",
    og: {
      type: "article"
    }
  }
};
export default function InformationsMetaTags() {
  const props = tags["vod"];
  return /*#__PURE__*/_jsx(MetaTags, _objectSpread({}, props));
}